<template>
  <a-card class="container">
    <a-menu v-model="selectMenu" class="container-menu">
      <a-menu-item :key="1">基本设置</a-menu-item>
      <a-menu-item :disabled="!!!tempId" :key="2">报告描述</a-menu-item>
    </a-menu>
    <a-row class="container-body">
      <component :is="currentCom" />
    </a-row>
  </a-card>
</template>
<script>
import Baicset from './baicset.vue'
import ReportDesc from './reportDesc.vue'

export default {
  name: 'Addtemp',
  components: { Baicset, ReportDesc },
  data() {
    return {
      selectMenu: [1],
      tempId: this.$route.query.id,
      tempInfo: this.$route.query,
    }
  },
  created() {
    const id = this.$route.query.id
    if (id) {
      this.tempId = id
    }
  },
  provide() {
    return {
      setTempId: (id) => (this.tempId = id),
      getTempId: () => this.tempId,
      getTemp: () => this.tempInfo,
      setTemp: (tempInfo) => (this.tempInfo = { ...this.tempInfo, ...tempInfo }),
    }
  },
  computed: {
    currentCom() {
      return this.selectMenu[0] == 1 ? Baicset : ReportDesc
    },
  },
  methods: {},
}
</script>
<style scoped lang="less">
.container {
  height: 100%;
  width: 100%;
  ::v-deep .ant-card-body {
    display: flex;
    height: 100%;
    width: 100%;
    .container-menu {
      width: 180px;
    }
    .container-body {
      flex: 1;
    }
  }
}
</style>
